<template>
  <div class="logo-loader" :style="{color: (color === 'white') ? 'white !important' : '#2c3e50'}">
    <div class="logo-loader__logo">
      <img v-if="color === 'white'" src="@/assets/chatbotspl_logo_white.png" alt="Chatbots logo">
      <img v-if="color === 'dark'" src="@/assets/chatbotspl_logo_dark.png" alt="Chatbots logo">
    </div>
    <p class="logo-loader__title">{{ text }}</p>
    <p
      ref="longerThanUsual"
      class="logo-loader__smaller-text"
      style="opacity: 0"
    >{{ $t('component.loader.longerThanUsual') }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: this.$t('component.loader.loading'),
      longerThanUsual: false,
    }
  },

  props: ['color'],

  methods: {
    setText(v) {
      this.text = v
    },

    showLongerThanUsualInfo() {
      this.$refs.longerThanUsual.style.opacity = 1
    },

    hideLongerThanUsualInfo() {
      this.$refs.longerThanUsual.style.opacity = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
  font-weight: 700;

  &__title {
    margin-top: 12px;
    margin-bottom: 0;
  }

  &__smaller-text {
    font-size: 0.5em;
    font-weight: 400;
    font-style: italic;
  }

  &__logo {
    width: 75px;
    animation-name: bounce;
    animation-iteration-count: infinite;
    animation-duration: 1.5s;

    & > img {
      width: 100%;
    }
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px) scaleY(1.1);
  }
  60% {
    transform: translateY(-15px);
  }
}
</style>
